<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card shadow="always">
          <div class="wrap">
            <i class="el-icon-s-data"></i>
            <div>
              <h4>全部评审</h4>
              <p>{{ homeTotal.AllEntries }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="always">
          <div class="wrap">
            <i class="el-icon-s-custom" style="color: #67c23a"></i>
            <div>
              <h4>待评审</h4>
              <p>{{ homeTotal.NotEvaluatedEntries }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="always">
          <div class="wrap">
            <i class="el-icon-s-finance" style="color: #409eff"></i>
            <div>
              <h4>已评审</h4>
              <p>{{ homeTotal.EvaluatedEntries }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px" v-if="videolist.length > 0">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>培训视频</span>
        </div>
        <ul class="v-list">
          <li v-for="item in videolist" :key="item.url" @click="getVideo(item.url)">
            <img src="../../assets/video.webp" alt="" />
            <p>{{ item.title }}</p>
            <span>{{ item.time }}</span>
          </li>
        </ul>

      </el-card>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-card>
        <div class="info">
          <h4>建议评分分布如下:</h4>
        </div>
        <div class="table-wrap">
          <el-table :data="rankList" border style="width: 30%;border-radius: 8px" align="center">
            <el-table-column label="评级" prop="level" width="80" align="center" />
            <el-table-column label="得分区间" prop="scoreRange" width="120" align="center" />
            <el-table-column label="占比" prop="ratio" align="center">
              <template #default="{ row }">
                <span :style="{ color: row.descColor }">{{ row.ratio }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-row>
    <!-- 视频播放弹窗 -->
    <el-dialog title="在线播放" :visible.sync="videoDialogVisible" width="40%" @close="resetsrc">
      <video :src="thisSrc" controls="controls" width="100%">
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        MatchName: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      homeTotal: {
        AllEntries: '',
        NotEvaluatedEntries: '',
        EvaluatedEntries: ''
      },
      videolist: [
        {
          title: '这是视频1',
          url: '',
          time: '2022-20-20'
        }
      ],
      // 视频在线播放弹窗
      videoDialogVisible: false,
      // 当前视频url
      thisSrc: '',
      rankList: [
        { level: 'A', scoreRange: '90-100分', ratio: '10%', descColor: '' },
        { level: 'B', scoreRange: '80-90分', ratio: '20%', descColor: '' },
        { level: 'C', scoreRange: '70-80分', ratio: '30%', descColor: '' },
        { level: 'D', scoreRange: '60-70分', ratio: '40%', descColor: '' },
        { level: 'E', scoreRange: '＜60分', ratio: '建议不出现', descColor: '#f56c6c' }
      ]
    }
  },
  created() {
    this.getHomeTotal()
    //   默认获取列表
    this.getVideoList()
  },
  methods: {
    async getHomeTotal() {
      const { data: res } = await this.$http.get(
        '/api/HomeTotal/GetJudgesTotal'
      )
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      this.homeTotal = res.Data.homeTotal
    },
    //   获取视频列表
    async getVideoList() {
      const { data: res } = await this.$http.get(
        '/api/TrainingVideo/GetAllVideoes',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.videolist = res.Data.trainingVideos.map((item) => {
        return {
          title: item.VideoName,
          url: process.env.VUE_APP_BASE_URL + item.FileName,
          time: this.$moment(item.CreateTime).format('YYYY-MM-DD')
        }
      })
    },
    // 获取当前视频src
    getVideo(url) {
      this.videoDialogVisible = true
      this.thisSrc = url
      // console.log(url)
    },
    // 关闭弹窗重置src
    resetsrc() {
      this.thisSrc = ''
    }
  }
}
</script>
<style lang="less" scoped>
.v-list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;

  li {
    list-style: none;
    margin: 10px;

    img {
      width: 200px;
      border-radius: 5px;
      border: 1px solid #ddd;
      padding: 3px;
    }

    p {
      font-size: 14px;
      margin: 0;
      width: 200px;
    }

    span {
      font-size: 12px;
    }
  }
}

.wrap {
  display: flex;
  justify-content: space-between;

  i {
    font-size: 80px;
    color: #40c9c6;
  }

  h4 {
    font-size: 25px;
    margin: 0;
    color: #666;
  }

  p {
    font-size: 30px;
    color: #999;
    margin: 5px 0;
  }
}

.infouse {
  p {
    font-size: 14px;
    color: #666;
  }
}

.el-card {
  min-width: auto;
}

.signchart {
  margin-top: 20px;
}
</style>
